import FundDetailsTabRow from 'components/Pages/FundsCenter/FundDetails/FundDetailsTabRow';
import { RichText } from '@sitecore-jss/sitecore-jss-nextjs';
import AccordionDefault from 'components/Sections/Accordion/AccordionDefault';
import FundDetailsTabSkeleton from 'components/Pages/FundsCenter/FundDetails/FundDetailsTabSkeleton';
import AlertMessageBase from 'components/Generic/AlertMessageBase';
import { useI18n } from 'next-localization';
import usePayload from 'hooks/useFundDetailsRequestPayload';
import useHelpers from 'hooks/helpers';
import styles from '../../styles/FundDetailsPodcastTab.module.scss';
import graphqlClientFactory from 'lib/graphql-client-factory';
import {
  PodcastDocument,
  PodcastQuery_search_ItemSearchResults_results_DataBridgeFund,
  PodcastQueryVariables,
} from 'components/graphql/Podcast.graphql';
import { useEffect, useState } from 'react';

const FundDetailsPodcastTab = () => {
  const { t } = useI18n();
  const { language, fund } = usePayload();
  const { getErrorDictionary } = useHelpers();
  const [podcastData, setPodcastData] =
    useState<PodcastQuery_search_ItemSearchResults_results_DataBridgeFund>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(false);

  const graphQLClient = graphqlClientFactory();

  useEffect(() => {
    setIsLoading(true);
    (async () => {
      try {
        const result = await graphQLClient.request<PodcastQueryVariables>(
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          PodcastDocument as any,
          {
            pageSize: 1,
            language: language,
            fundId: fund,
          }
        );
        const podcastUrl = new URL(
          result.search.results[0]?.podcastUrl.value.replace('/episode', '/embed/episode/')
        );
        if (podcastUrl) {
          podcastUrl.searchParams.set('theme', '0');
        }
        setPodcastData(
          {
            ...result.search.results[0],
            url: podcastUrl,
          } ?? {}
        );
        setIsLoading(false);
      } catch (e) {
        setError(e);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <section className="default-section-padding background-white">
      <FundDetailsTabRow>
        {isLoading ? (
          <FundDetailsTabSkeleton />
        ) : error ? (
          <AlertMessageBase type="error" title={t(getErrorDictionary(error))} />
        ) : podcastData ? (
          <>
            <h2>{podcastData.podcastTitle.value}</h2>
            <RichText
              className="mt-5 body-default text-grey d-grid gap-3"
              field={{ value: podcastData.podcastDescription.value }}
            />
            <div className="mt-6">
              <iframe
                className={styles.iframe}
                src={podcastData.url}
                width="100%"
                height="242"
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
                title={podcastData.podcastTitle.value}
              />
            </div>
            {podcastData.podcastTranscript.value && (
              <AccordionDefault
                title={{ value: t('transcript') }}
                description={{ value: podcastData.podcastTranscript.value }}
                className={`mt-3 ${styles['accordion-item']}`}
              />
            )}
          </>
        ) : (
          <div className="body-default">{t('noResultsMessage')}</div>
        )}
      </FundDetailsTabRow>
    </section>
  );
};

export default FundDetailsPodcastTab;
